// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"332":"instructions","641":"minasidor"}[chunkId] + "." + {"332":"571f1133","641":"6389f72b"}[chunkId] + ".js";
};